export function preventDefault(e) {
  e = e || window.event;
  if (e.preventDefault) {
    e.preventDefault();
  }
  e.returnValue = false;
}




/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/utils/Event.js
 **/